module.exports = __webpack_public_path__ + "static/media/marcacoesRegister.67178dbe.jpg";